/** Login */
export default {
  label: {
    code: 'SMS Login',
    pswd: 'Password Login'
  },
  phone: 'Phone Number',
  password: 'Login Password',
  code: '{type} Verification',
  sms: 'SMS',
  img: 'Image',
  getCode: 'Send',
  login: 'Login',
  // Choose Merchant
  choose: 'Choose Merchant',
  // Tips
  agree: 'Unregistered phone numbers will be automatically registered. Checking means you agree to and accept',
  agreement: '《Merchant Platform User Agreement》',
  second: 's',
  // WeChat Login
  wx: 'WeChat Login',
  // Activity Management Platform
  activity_platform: {
    title: 'Activity Management Platform',
    subtitle: 'From simple to complex, endless variations and settings to meet your activity needs',
    features: [
      'Publish large-scale activities through multiple rounds and category groups',
      'Increase exposure for your activities through popularity rankings',
      'Achieve multi-form promotion through ad loading',
      'Accurately select the best participants through multi-dimensional evaluation',
      'Showcase colorful scenes through image and video uploads'
    ]
  },
  // Evaluation and Advancement
  evaluation: {
    title: 'Evaluation & Advancement',
    subtitle: 'Multi-dimensional evaluation for the most fair and formal selection scoring',
    features: [
      'Create multi-dimensional scoring schemes for different groups, compound selection',
      'Choose between scoring and judging evaluation methods',
      'Multiple judges evaluate and score simultaneously for fair authority',
      'One-click operation for participant screening, advancement and elimination',
      'Create certificates and rankings for outstanding participants'
    ]
  },
  // Wonderful Moments
  moments: {
    title: 'Wonderful Moments',
    subtitle: 'Record precious moments in activities through images and videos',
    features: [
      'Upload images or videos, publish on mobile as mementos of wonderful moments',
      'Effectively manage through tags and categories of images and videos',
      'Download images and videos for users to permanently keep highlight moments'
    ]
  },
  // Popularity Rankings
  popularity: {
    title: 'Popularity Rankings',
    subtitle: 'Perfectly reflect activity popularity through ranking lists',
    features: [
      'Like rankings, one vote per person shows high activity popularity',
      'Gift rankings, contribute to your supported popular contestants',
      'Multi-stage rankings show different popularity at various stages',
      'Multi-group rankings showcase high popularity participants in different groups'
    ]
  }
}



// WEBPACK FOOTER //
// ./src/langs/en/login.js